module.exports = __webpack_public_path__ + "static/media/sliderItem1.8390354a.JPG";